import React, { useState, useEffect } from "react";
import Dropdown from "components/Dropdowns/FormDropdown";
import { useCore } from "store/core";
import SelectReact from "react-select";
const WAIT_INTERVAL = 1000;
const ENTER_KEY = 13;
const Multiselect = (props) => {
  const { form, field } = props;
  const { list } = useCore();
  // state showing if dropdown is open or closed
  const [dropdown, setDropdown] = useState(false);
  // managing dropdown items (list of dropdown items)

  // contains selected items
  const [selectedItems, setSelected] = useState([]);

  useEffect(() => {
    if (field.value) {
      if (props.valueOnly) {
        setSelected(
          props.options.filter((item) => field.value.includes(item.value))
        );
      } else {
        setSelected(list(field.value));

        form.setFieldValue(
          field.name,
          field.value.map((item) => item.id)
        );
      }
    }
  }, [props.options]);

  const onChangeHandler = (items) => {
    setSelected(items);

    form.setFieldValue(
      field.name,
      items.map((item) => item.value)
    );
  };

  return (
    <div className="text-xs col-span-2" style={{ zIndex: 0 }}>
      <label
        className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
        htmlFor={field.name}
      >
        {props.label}
      </label>
      <SelectReact
        placeholder="انتخاب..."
        value={selectedItems}
        onChange={onChangeHandler}
        options={props.options}
        menuPortalTarget={document.body}
        styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
        isClearable={true}
        isMulti
      />
      <span className="text-xs text-red-400">{form.errors[field.name]}</span>
    </div>
  );
};

export default Multiselect;
